import axios from "axios";

export default function useCMS () {
    const labels = window.cmsData.labels;
    const page = window.cmsData.page;
    const pageURLs = window.cmsData.pageURLs;
    const urlParams = window.cmsData.urlParams;

    const getLabel = (id) => {
        return labels[id]
    }

    const getDynamicMessage = (id, map = {}) => {
        const params = new URLSearchParams();
        params.append('id', id)
        params.append('map', new URLSearchParams(map))
        return axios.post('/actions/misc.cfc?method=getDynamicMessage', params);
    }

    const getPageVar = (id) => {
        return page[id];
    }

    const getPageUrl = (id) => {
        return pageURLs[id];
    }

    const getUrlParam = (id) => {
        return urlParams[id]
    }

    return {
        labels,
        page,
        pageURLs,
        urlParams,
        getLabel,
        getDynamicMessage,
        getPageVar,
        getPageUrl,
        getUrlParam
    }
}
